export default function BlogSection() {
  const blogPosts = [
    {
      category: 'Mawari News',
      title: 'mmWave DE VTuber 凪乃ましろ スペシャル3Dトークライブ 3/17開催',
      date: '2026年2月26日',
      excerpt: '5Gミリ波・小型整3D配信が切り拓く新たなXRの可能性。等身大VTuberと同じ空間で体験を共有する3D映像イベント「mmWAVE DE VTuber〜凪乃ましろ スペシャル3Dトークライブ」が3月17日に開催されます。',
      image: 'https://public.readdy.ai/ai/img_res/436f9b703cfcfbf0a246e4ed391c5aea.jpg',
      link: 'https://prtimes.jp/main/html/rd/p/000000026.000070300.html',
    },
    {
      category: 'Mawari News',
      title: 'Mawariエコシステムの成長',
      date: '2025年1月8日',
      excerpt: 'Mawariネットワークの拡大と、新しいパートナーシップについての最新情報をお届けします。',
      image: 'https://readdy.ai/api/search-image?query=Growing%20network%20visualization%20with%20interconnected%20nodes%20expanding%20ecosystem%20concept%20soft%20gradient%20pink%20and%20purple%20colors%20modern%20abstract%20digital%20art%20clean%20background&width=600&height=400&seq=blog-002&orientation=landscape',
      link: null,
    },
    {
      category: 'AI & AR',
      title: 'AIコンパニオンの未来',
      date: '2025年1月3日',
      excerpt: 'AIとARが融合した新しいコミュニケーション体験が、私たちの日常をどう変えるのか。',
      image: 'https://readdy.ai/api/search-image?query=Friendly%20AI%20hologram%20companion%20glowing%20softly%20interacting%20with%20person%20futuristic%20but%20warm%20atmosphere%20soft%20pink%20and%20purple%20light%20optimistic%20mood%20clean%20modern%20style&width=600&height=400&seq=blog-003&orientation=landscape',
      link: null,
    },
  ];

  return (
    <section id="blog" className="py-24 px-6 bg-gradient-to-b from-white to-purple-50/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            最新記事
          </h2>
          <p className="text-xl text-gray-600">
            XR・クリプト・Mawariの最新情報をお届け
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {blogPosts.map((post, index) => (
            <article
              key={index}
              onClick={() => {
                if (post.link) {
                  window.open(post.link, '_blank', 'noopener,noreferrer');
                } else if (window.REACT_APP_NAVIGATE) {
                  window.REACT_APP_NAVIGATE('/news');
                }
              }}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 cursor-pointer"
            >
              <div className="relative w-full h-56">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4 px-4 py-2 bg-white/90 backdrop-blur-sm text-gray-900 text-sm font-semibold rounded-full">
                  {post.category}
                </div>
                {post.link && (
                  <div className="absolute top-4 right-4 px-3 py-1 bg-pink-500 text-white text-xs font-bold rounded-full animate-pulse">
                    🔥 本日発表
                  </div>
                )}
              </div>
              <div className="p-8">
                <p className="text-sm text-gray-500 mb-3">{post.date}</p>
                <h3 className="text-xl font-bold text-gray-900 mb-4 leading-tight">
                  {post.title}
                </h3>
                <p className="text-base text-gray-600 leading-relaxed mb-6">
                  {post.excerpt}
                </p>
                <div className="flex items-center text-pink-500 font-semibold">
                  記事を読む
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={() => {
              if (window.REACT_APP_NAVIGATE) {
                window.REACT_APP_NAVIGATE('/news');
              }
            }}
            className="px-10 py-4 bg-gradient-to-r from-pink-500 to-purple-500 text-white text-lg font-bold rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
          >
            すべての記事を見る
          </button>
        </div>
      </div>
    </section>
  );
}